export default __webpack_public_path__ + "static/media/kitchen3-afterE-2048w.c03f2e64.webp";